import React from 'react';
import TestimonialContent from './testimonial-6';
const Six_wraper = () => {
    return (
        <section className="p-top-50">        
            <TestimonialContent h3={<h3>700k+ Happy Enterpreneurs</h3>}/>
        </section>
    )
}
export default Six_wraper;